import React, { type ReactElement } from 'react';

interface IconStars47Props {
  width?: number;
  height?: number;
  className?: string;
}

export function IconStars47({
  width = 104,
  height = 21,
  className,
}: IconStars47Props): ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 104 21"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M10.6744 3.50738C10.3538 2.60932 9.07775 2.62677 8.78191 3.53327L7.61755 7.10102C7.48329 7.51241 7.09965 7.79077 6.6669 7.79077H2.69885C1.77097 7.79077 1.3434 8.94473 2.04726 9.54933L5.55289 12.5606C5.85516 12.8203 5.97443 13.2346 5.85648 13.6152L4.62932 17.5751C4.34561 18.4906 5.3878 19.2422 6.16691 18.684L9.31334 16.4297C9.67369 16.1716 10.161 16.1814 10.5106 16.454L13.5593 18.8308C14.3266 19.429 15.4097 18.6904 15.1328 17.7577L13.8927 13.5792C13.778 13.193 13.9063 12.7757 14.2181 12.5207L17.8315 9.56477C18.5589 8.96969 18.1381 7.79077 17.1983 7.79077H12.908C12.4853 7.79077 12.1083 7.525 11.9662 7.12691L10.6744 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M31.6744 3.50738C31.3538 2.60932 30.0777 2.62677 29.7819 3.53327L28.6176 7.10102C28.4833 7.51241 28.0996 7.79077 27.6669 7.79077H23.6988C22.771 7.79077 22.3434 8.94473 23.0473 9.54933L26.5529 12.5606C26.8552 12.8203 26.9744 13.2346 26.8565 13.6152L25.6293 17.5751C25.3456 18.4906 26.3878 19.2422 27.1669 18.684L30.3133 16.4297C30.6737 16.1716 31.161 16.1814 31.5106 16.454L34.5593 18.8308C35.3266 19.429 36.4097 18.6904 36.1328 17.7577L34.8927 13.5792C34.778 13.193 34.9063 12.7757 35.2181 12.5207L38.8315 9.56477C39.5589 8.96969 39.1381 7.79077 38.1983 7.79077H33.908C33.4853 7.79077 33.1083 7.525 32.9662 7.12691L31.6744 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M52.6744 3.50738C52.3538 2.60932 51.0777 2.62677 50.7819 3.53327L49.6176 7.10102C49.4833 7.51241 49.0996 7.79077 48.6669 7.79077H44.6988C43.771 7.79077 43.3434 8.94473 44.0473 9.54933L47.5529 12.5606C47.8552 12.8203 47.9744 13.2346 47.8565 13.6152L46.6293 17.5751C46.3456 18.4906 47.3878 19.2422 48.1669 18.684L51.3133 16.4297C51.6737 16.1716 52.161 16.1814 52.5106 16.454L55.5593 18.8308C56.3266 19.429 57.4097 18.6904 57.1328 17.7577L55.8927 13.5792C55.778 13.193 55.9063 12.7757 56.2181 12.5207L59.8315 9.56477C60.5589 8.96969 60.1381 7.79077 59.1983 7.79077H54.908C54.4853 7.79077 54.1083 7.525 53.9662 7.12691L52.6744 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M73.6744 3.50738C73.3538 2.60932 72.0777 2.62677 71.7819 3.53327L70.6176 7.10102C70.4833 7.51241 70.0996 7.79077 69.6669 7.79077H65.6988C64.771 7.79077 64.3434 8.94473 65.0473 9.54933L68.5529 12.5606C68.8552 12.8203 68.9744 13.2346 68.8565 13.6152L67.6293 17.5751C67.3456 18.4906 68.3878 19.2422 69.1669 18.684L72.3133 16.4297C72.6737 16.1716 73.161 16.1814 73.5106 16.454L76.5593 18.8308C77.3266 19.429 78.4097 18.6904 78.1328 17.7577L76.8927 13.5792C76.778 13.193 76.9063 12.7757 77.2181 12.5207L80.8315 9.56477C81.5589 8.96969 81.1381 7.79077 80.1983 7.79077H75.908C75.4853 7.79077 75.1083 7.525 74.9662 7.12691L73.6744 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M94.6744 3.50738C94.3538 2.60932 93.0777 2.62677 92.7819 3.53327L91.6176 7.10102C91.4833 7.51241 91.0996 7.79077 90.6669 7.79077H86.6988C85.771 7.79077 85.3434 8.94473 86.0473 9.54933L89.5529 12.5606C89.8552 12.8203 89.9744 13.2346 89.8565 13.6152L88.6293 17.5751C88.3456 18.4906 89.3878 19.2422 90.1669 18.684L93.3133 16.4297C93.6737 16.1716 94.161 16.1814 94.5106 16.454L97.5593 18.8308C98.3266 19.429 99.4097 18.6904 99.1328 17.7577L97.8927 13.5792C97.778 13.193 97.9063 12.7757 98.2181 12.5207L101.831 9.56477C102.559 8.96969 102.138 7.79077 101.198 7.79077H96.908C96.4853 7.79077 96.1083 7.525 95.9662 7.12691L94.6744 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <mask
        height="18"
        id="mask0_3439_24007"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="18"
        x="85"
        y="2"
      >
        <path
          clipRule="evenodd"
          d="M94.6744 3.50738C94.3538 2.60932 93.0777 2.62677 92.7819 3.53327L91.6176 7.10102C91.4833 7.51241 91.0996 7.79077 90.6669 7.79077H86.6988C85.771 7.79077 85.3434 8.94473 86.0473 9.54933L89.5529 12.5606C89.8552 12.8203 89.9744 13.2346 89.8565 13.6152L88.6293 17.5751C88.3456 18.4906 89.3878 19.2422 90.1669 18.684L93.3133 16.4297C93.6737 16.1716 94.161 16.1814 94.5106 16.454L97.5593 18.8308C98.3266 19.429 99.4097 18.6904 99.1328 17.7577L97.8927 13.5792C97.778 13.193 97.9063 12.7757 98.2181 12.5207L101.831 9.56477C102.559 8.96969 102.138 7.79077 101.198 7.79077H96.908C96.4853 7.79077 96.1083 7.525 95.9662 7.12691L94.6744 3.50738Z"
          fill="white"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_3439_24007)">
        <rect fill="#F3F3F0" height="17" rx="1" width="5" x="98" y="3" />
      </g>
    </svg>
  );
}
